<nav [ngClass]="(isLoggedIn$ | async) ? 'authed' : 'unauthed'" id="mainNav">
  <header>
    <img src="assets/images/SMIPayTribal_Header.png" alt="Header" class="header-img" />
    <button class="global-nav-toggler navbar-toggler" type="button" aria-expanded="false"
      aria-label="Toggle Global Navigation" (click)="toggleGlobalNav($event)" #mobileNavToggleBtn>
      <b class="fa fa-bars fa-lg"></b>
    </button>
  </header>
  <div class="navbar navbar-expand-lg page-nav-block">
    <div id="global-nav-block" class="collapse navbar-collapse" [ngClass]="{'show': isGlobalNavOpen}" #globalNavBlock>
      <div *ngIf="(isLoggedIn$ | async); else elseBlock" class="authed-nav-block">
        <div *ngIf="(usertype$ | async) === 'employer'; else ncpNavBlock" class="employer-nav-block" #employerNavBlock>
          <ul ngbNav #navEmployer="ngbNav" class="nav-pills global-nav-menu" role="list">
            <li [ngbNavItem]="1" role="listitem" [attr.tabindex]="-1">
              <a class="nav-link global-nav-link" [routerLink]="['/employer/home']" tabindex="0">Home</a>
            </li>
            <li [ngbNavItem]="4" ngbDropdown role="listitem" [attr.tabindex]="-1">
              <a href (click)="false" class="nav-link" ngbDropdownToggle tabindex="0">Helpful Links
                <span class="fa fa-chevron-circle-down"></span>
              </a>
              <div class="dropdown-menu" ngbDropdownMenu>
                <a class="dropdown-child" [routerLink]="['/employer/achd/information']" ngbDropdownItem>ACH Debit </a>
                <a class="dropdown-child" [routerLink]="['/employer/eft/information']" ngbDropdownItem>ACH Credit
                  (EFT/EDI) </a>
                <a class="dropdown-child" download="employereft" target="_blank" href="/assets/forms/employereft.pdf"
                  ngbDropdownItem>
                  Employer ACH Credit (EFT/ EDI) Packet
                  <i class="fa fa-download" aria-hidden="true"></i></a>
                <a class="dropdown-child"
                  href="https://www.nacha.org/system/files/resources/Child-Support-User-%20Guide-%20Feb%202017%202.pdf"
                  target="_blank" ngbDropdownItem>NACHA&rsquo;s User Guide for Electronic Payments</a>
                <a class="dropdown-child" [routerLink]="['/demo']" ngbDropdownItem>Website Help</a>
              </div>
            </li>
            <li class="nav-spacing" aria-hidden="true" role="presentation"></li>
            <li [ngbNavItem]="6" ngbDropdown role="listitem" [attr.tabindex]="-1">
              <a href (click)=false class="nav-link" ngbDropdownToggle tabindex="0">Account
                <span class="fa fa-user-circle-o"></span>
              </a>
            </li>
          </ul>
          <div [ngbNavOutlet]="navEmployer" class="authed-global-nav-block"></div>

        </div>
        <ng-template #ncpNavBlock>
          <div class="ncp-nav-block" id="ncp-nav-block">
            <ul ngbNav #navNcp="ngbNav" class="nav-pills global-nav-menu" role="list">
              <li [ngbNavItem]="1" role="listitem" [attr.tabindex]="-1">
                <a class="nav-link global-nav-link" [routerLink]="['/ncp/achd/landing']" tabindex="0">Home</a>
              </li>
              <li [ngbNavItem]="2" ngbDropdown role="listitem" [attr.tabindex]="-1">
                <a href (click)="false" class="nav-link" ngbDropdownToggle tabindex="0">ACH Debit
                  <span class="fa fa-chevron-circle-down"></span>
                </a>
                <div class="dropdown-menu" ngbDropdownMenu>
                  <a class="dropdown-child" [routerLink]="['/ncp/achd/landing']" ngbDropdownItem>ACH Debit Home</a>
                  <a class="dropdown-child" [routerLink]="['/ncp/achd/payment']" ngbDropdownItem>Create New
                    Payment</a>
                  <a class="dropdown-child" [routerLink]="['/ncp/achd/paymentaccount']" ngbDropdownItem>Manage Bank
                    Accounts</a>
                </div>
              </li>
              <li [ngbNavItem]="3" ngbDropdown role="listitem" [attr.tabindex]="-1">
                <a href (click)=false class="nav-link" ngbDropdownToggle tabindex="0">Credit Card
                  <span class="fa fa-chevron-circle-down"></span>
                </a>
                <div class="dropdown-menu" ngbDropdownMenu>
                  <a class="dropdown-child" [routerLink]="['/ncp/creditcard/landing']" ngbDropdownItem>Credit Card Home
                  </a>
                  <a *ngIf="(isLoggedIn$ | async)" class="dropdown-child" [routerLink]="['/ncp/creditcard/payment/landing']" ngbDropdownItem>Make a Credit Card
                    Payment
                  </a>
                  <a *ngIf="!(isLoggedIn$ | async)" class="dropdown-child" [routerLink]="['/ncp/creditcard/payment']" ngbDropdownItem>Make a Credit Card
                    Payment
                  </a>
                 
                  <a *ngIf="(isLoggedIn$ | async)" class="dropdown-child" [routerLink]="['/ncp/creditcard/recurring/manage-cards']" ngbDropdownItem>Manage Recurring Credit Cards
                  </a>
                  
                </div>
              </li>

              <li [ngbNavItem]="3" ngbDropdown role="listitem" [attr.tabindex]="-1">
                <a href (click)=false class="nav-link" ngbDropdownToggle tabindex="0">Pay by Text
                  <span class="fa fa-chevron-circle-down"></span>
                </a>
                <div class="dropdown-menu" ngbDropdownMenu>
                  <a class="dropdown-child" [routerLink]="['/ncp/paybytext/landing']" ngbDropdownItem>Pay by Text Home
                  </a>
                  <a class="dropdown-child" [routerLink]="['/ncp/paybytext/payment']" ngbDropdownItem>Schedule New Text
                  </a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-child" [routerLink]="['/ncp/paybytext/settings']" ngbDropdownItem>Pay by Text Settings
                  </a>
                </div>
              </li>

              <li [ngbNavItem]="3" ngbDropdown role="listitem" [attr.tabindex]="-1">
                <a href (click)=false class="nav-link" ngbDropdownToggle tabindex="0">Online Statements
                  <span class="fa fa-chevron-circle-down"></span>
                </a>
                <div class="dropdown-menu" ngbDropdownMenu>
                  <a class="dropdown-child" [routerLink]="['/ncp/online-statements/landing']" ngbDropdownItem>Online Statements Home
                  </a>
                  <a class="dropdown-child" [routerLink]="['/ncp/online-statements/print-coupon']" ngbDropdownItem>Print Coupon
                  </a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-child" [routerLink]="['/ncp/online-statements/settings']" ngbDropdownItem>Online Statements Settings
                  </a>
                </div>
              </li>

              <li [ngbNavItem]="5" ngbDropdown role="listitem" [attr.tabindex]="-1">
                <a href (click)="false" class="nav-link" ngbDropdownToggle tabindex="0">Helpful Links
                  <span class="fa fa-chevron-circle-down"></span>
                </a>
                <div class="dropdown-menu" ngbDropdownMenu>
                  <a class="dropdown-child" [routerLink]="['/employer/achd/information']" ngbDropdownItem>ACH Debit </a>
                  <a class="dropdown-child" [routerLink]="['/employer/eft/information']" ngbDropdownItem>ACH Credit
                    (EFT/EDI) </a>
                  <a class="dropdown-child" download="employereft" target="_blank" href="/assets/forms/employereft.pdf"
                    ngbDropdownItem>
                    Employer ACH Credit (EFT/ EDI) Packet
                    <i class="fa fa-download" aria-hidden="true"></i></a>
                  <a class="dropdown-child"
                    href="https://www.nacha.org/system/files/resources/Child-Support-User-%20Guide-%20Feb%202017%202.pdf"
                    target="_blank" ngbDropdownItem>NACHA&rsquo;s User Guide for Electronic Payments</a>
                  <a class="dropdown-child" [routerLink]="['/demo']" ngbDropdownItem>Website Help</a>
                </div>
              </li>
              <li class="nav-spacing" aria-hidden="true" role="presentation"></li>
              <li [ngbNavItem]="5" ngbDropdown role="listitem" [attr.tabindex]="-1">
                <a href (click)="false" class="nav-link global-nav-link" ngbDropdownToggle tabindex="0">Account
                  <span class="fa fa-user-circle-o"></span>
                </a>
              </li>
            </ul>
            <div [ngbNavOutlet]="navNcp" class="authed-global-nav-block"></div>
          </div>
        </ng-template>
      </div>
      <ng-template #elseBlock>
        <ul ngbNav #nav="ngbNav" class="nav-pills global-nav-menu" role="list">
          <li [ngbNavItem]="1" role="listitem" [attr.tabindex]="-1"><a class="nav-link global-nav-link" [routerLink]="['/home']" tabindex="0">Home</a></li>
          <li [ngbNavItem]="4" ngbDropdown role="listitem" [attr.tabindex]="-1">
            <a href class="nav-link global-nav-link dropdown-menu-toggle" (click)=false ngbDropdownToggle tabindex="0">Helpful Links
              <span class="fa fa-chevron-circle-down"></span>
            </a>
            <div class="dropdown-menu" ngbDropdownMenu>
              <a class="dropdown-child" [routerLink]="['/demo']" ngbDropdownItem>Website Help</a>
            </div>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="unauthed-global-nav-block"></div>
      </ng-template>
    </div>
  </div>
</nav>
